import { Record as record, List } from 'immutable';

import trainTime from '../../lib/TrainTime';
import { construct, resolveAll, fields, resolve } from '../../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../helpers/Records';

import AuthToken from '../customer/AuthToken';
import CustomerAddress from '../customer/Address';
import UserPreferences from '../customer/UserPreferences';
import DeactivationRequest from './DeactivationRequest';

const childAge = trainTime.duration('P16Y');

const schema = {
    id: [ fields.number ],
    title: [ fields.string ],
    firstNames: [ fields.string ],
    surname: [ fields.string ],
    email: [ fields.string ],
    telephoneNumber: [ fields.string ],
    created: [ fields.datetime ],
    lastLogin: [ fields.datetime ],
    lastUpdated: [ fields.datetime ],
    dateOfFirstPurchase: [ fields.datetime ],
    photocardId: [ fields.string ],
    source: [ fields.string ],
    dateOfBirth: [ fields.datetime ],
    accessToken: [ resolve.as(AuthToken) ],
    smartcardRegistered: [ fields.boolean ],
    brandChosen: [ fields.boolean, false ],
    addresses: [ resolveAll.as(CustomerAddress), new List()],
    preferences: [ resolve.as(UserPreferences) ],
    isOver16: [ fields.boolean ],
    identityProviders: [ resolveAll.with(fields.string), new List() ],
    deactivationRequests: [ resolveAll.as(DeactivationRequest), new List() ],
    autoDrOptedIn: [fields.boolean, false],
    autoDelayRepayEmail: [fields.boolean, false],
    autoDelayRepayApp: [fields.boolean, false],
};

class Customer extends record(getDefaults(schema)) {

    static fromJSON(json = {}) {
        return construct(Customer, json, getResolvers(schema));
    }

    isChild() {
        const maxChildDate = trainTime().subtract(childAge);
        return this.dateOfBirth && this.dateOfBirth.isAfter(maxChildDate);
    }

    hasIdentityProvider(provider) {
        return this.identityProviders && this.identityProviders.some(p => p === provider);
    }

    removeIdentityProvider(provider) {
        return Customer.fromJSON({
            ...this.toJS(),
            identityProviders: this.identityProviders.filter(p => p !== provider)
        });
    }
}

export default Customer;



// WEBPACK FOOTER //
// ./src/records/customer/Customer.js